/**
 * 图片上传
 * 2019-05-28 chenxiaojian
 */

import React from 'react';
import { Icon } from 'antd';

import '../../style/common/imageView.css';

class Imageview extends React.Component {


    state = {
        size: 1,
        rotate: 0,
        left: '50%',
        top: '50%',
        transform: "rotate(0deg) scale(1) translate(-50%,-50%)"
    }

    handleCancel = () => {
        this.setState({
            size: 1,
            rotate: 0,
            left: '50%',
            top: '50%'
        });
        this.props.handleCancel()
    };

    handleWheel(e) {
        //判断鼠标滚轮的上下滑动
        let delta = e.deltaY
        // 缩小
        if (delta > 0) {
            this.changeSize(-0.2)
        }
        // 放大
        if (delta < 0) {
            this.changeSize(0.2)
        }

    }
    // 放大缩小
    changeSize(num) {
        if ((this.state.size > .5 && num < 0) || (this.state.size < 2.5 && num > 0)) {
            let size = this.state.size + num
            let transform = "translate(-50%,-50%) rotate(" + this.state.rotate + "deg) scale(" + size + ")";
            this.setState({size: size, transform: transform});
        }
    }

    // 旋转
    rotation(deg) {
        let rotate = this.state.rotate + deg
        let transform = "translate(-50%,-50%) rotate(" + rotate + "deg) scale(" + this.state.size + ")"
        this.setState({
            rotate: rotate,
            transform: transform
        });
    }


    // 获取图片的宽高
    // componentDidUpdate(prevProps) {
    //     let img = new Image()
    //     img.src = this.props.imgsrc
    //     img.onload = () => {
    //         this.setState({
    //             imgwidth: img.width,
    //             imgheight: img.height
    //         })
    //     }
    // }


    // 拖拽
    move(e) {
        let odiv = e.target;//获取目标元素
        //算出鼠标相对元素的位置
        let disX = e.clientX - odiv.offsetLeft;
        let disY = e.clientY - odiv.offsetTop;
        document.onmousemove = (e) => {       //鼠标按下并移动的事件
            //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
            this.setState({
                left: e.clientX - disX,
                top: e.clientY - disY
            })
        }

        document.onmouseup = (e) => {
            document.onmousemove = null;
            document.onmouseup = null;
        }
    }
    
    render() {
        const { src, visible } = this.props
        let dom = visible === true ?
            (
                <div onCancel={this.handleCancel} className={['visiblebox', visible ? 'show' : 'hide'].join(' ')} ref="visiblebox" onWheel={this.handleWheel.bind(this)}>
                    <img alt="" className="openimg" style={{ transform: this.state.transform, left: this.state.left, top: this.state.top }} src={src} onMouseDown={this.move.bind(this)} />

                    <div className="bgAll" onClick={this.handleCancel.bind(this)}></div>

                    <div className="viewbox">
                        <Icon type="zoom-out" onClick={this.changeSize.bind(this, -0.2)} className="view" style={{ fontSize: "20px" }} />
                        <Icon type="zoom-in" onClick={this.changeSize.bind(this, 0.2)} className="view" style={{ fontSize: "20px" }} />
                        <Icon type="undo" onClick={this.rotation.bind(this, -90)} className="view" style={{ fontSize: "20px" }} />
                        <Icon type="redo" onClick={this.rotation.bind(this, 90)} className="view" style={{ fontSize: "20px" }} />
                        <Icon className="close view" onClick={this.handleCancel.bind(this)} type="close" style={{ fontSize: "20px" }} />
                    </div>
                </div>
            ) : "";
        return dom;
    }
}

export default Imageview;